
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/contact",
      function () {
        return require("private-next-pages/about/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/contact"])
      });
    }
  